let oneTrustLoaded = false;

export const injectOneTrustScript = () => {
  const oneTrustId = window.REACT_APP_ONE_TRUST;

  if (!oneTrustId) {
    return;
  }

  if (oneTrustLoaded || (window as any).OneTrust) {
    return;
  }

  oneTrustLoaded = true;

  (window as any).OptanonWrapper = function () {};

  const autoBlockScript = document.createElement('script');
  autoBlockScript.src = `https://cdn.cookielaw.org/consent/${oneTrustId}/OtAutoBlock.js`;
  autoBlockScript.type = 'text/javascript';

  const sdkScript = document.createElement('script');
  sdkScript.src = 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js';
  sdkScript.type = 'text/javascript';
  sdkScript.setAttribute('data-domain-script', oneTrustId);
  sdkScript.charset = 'UTF-8';

  document.head.appendChild(autoBlockScript);
  document.head.appendChild(sdkScript);
};
